import script from "./FormButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormButton.vue?vue&type=script&setup=true&lang=ts"

import "./FormButton.vue?vue&type=style&index=0&id=394f7028&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394f7028"]])

export default __exports__